import React, { useCallback, useState } from 'react';

type State = {
  extra?: any;
  title?: string;
  hideBack?: boolean;
  prevTitle?: string;
  paddingBottom?: number;
  class?: string;
};

type Props = {
  children: any;
};

type Dispatch = {
  updateAccountModal: (data: Partial<State>) => void;
  peselNumberValue: string | null;
  isCpfPersonalId: boolean | null;
  birthDateValue: string | null;
  relatedDisabledFields: Record<string, boolean>;
  setRelatedDisabledFields: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
  setPeselNumberValue: (value: string | null) => void;
  setIsCpfPersonalId: (value: boolean | null) => void;
  setBirthDateValue: (value: string | null) => void;
};

const initialState: State = {
  title: '',
  extra: null,
  prevTitle: '',
  hideBack: true,
  class: ''
};

const AccountsStateContext = React.createContext<State | undefined>(undefined);
const AccountsDispatchContext = React.createContext<Dispatch | undefined>(
  undefined
);

export const AccountsModalProvider = (props: Props): JSX.Element => {
  const [state, setState] = useState(initialState);
  const [peselNumberValue, setPeselNumberValue] = useState<string | null>(null);
  const [isCpfPersonalId, setIsCpfPersonalId] = useState<boolean | null>(null);
  const [birthDateValue, setBirthDateValue] = useState<string | null>(null);

  const [relatedDisabledFields, setRelatedDisabledFields] = useState<
    Record<string, boolean>
  >({});

  const update = useCallback((params: State) => {
    setState({ extra: null, hideBack: false, ...params });
  }, []);

  return (
    <AccountsStateContext.Provider value={state}>
      <AccountsDispatchContext.Provider
        value={{
          updateAccountModal: update,
          peselNumberValue,
          isCpfPersonalId,
          setPeselNumberValue,
          setIsCpfPersonalId,
          relatedDisabledFields,
          setRelatedDisabledFields,
          birthDateValue,
          setBirthDateValue
        }}
      >
        {props.children}
      </AccountsDispatchContext.Provider>
    </AccountsStateContext.Provider>
  );
};

export function useAccountsModalState(): State {
  const context = React.useContext(AccountsStateContext);

  if (context === undefined) {
    throw new Error(
      'useAccountsState must be used within a AccountsModalProvider'
    );
  }

  return context;
}

export function useAccountsModalDispatch(): Dispatch {
  const context = React.useContext(AccountsDispatchContext);

  if (context === undefined) {
    return {
      updateAccountModal: () => {},
      peselNumberValue: null,
      isCpfPersonalId: null,
      setPeselNumberValue: () => {},
      setIsCpfPersonalId: () => {},
      relatedDisabledFields: {},
      setRelatedDisabledFields: () => {},
      birthDateValue: null,
      setBirthDateValue: () => {}
    };
  }

  return context;
}
